import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { ThemeContext } from '../../context/ThemeContext';

const ResumeButton = ({ title = 'Resume', link, onClick, className = '', style = {} }) => {
    const { theme, themes } = useContext(ThemeContext);
    const themeStyles = themes[theme];
    const glowColor = themeStyles.glowColor;
    const Button = link ? motion.a : motion.button;

    return (
        <Button
            {...(link
                ? { href: link, target: '_blank', rel: 'noopener noreferrer' }
                : { onClick })}
            className={`${link ? `text-xl mt-6 mb-5 ${themeStyles.text}` : ''} ${className}`.trim()}
            style={{
                display: 'inline-block',
                padding: '2.5px 30px',
                letterSpacing: '0.5px',
                borderRadius: '8px',
                border: `1px solid ${glowColor || 'rgba(255, 0, 0, 0.8)'}`,
                backgroundColor: 'transparent',
                position: 'relative',
                zIndex: 5,
                overflow: 'hidden',
                boxShadow: `0 0 5px ${glowColor || 'rgba(255, 0, 0, 0.8)'}`,
                transition: 'all 0.4s ease',
                cursor: 'pointer',
                textDecoration: link ? 'none' : undefined,
                ...style,
            }}
            whileHover={{
                scale: 1.06,
                boxShadow: `0 0 10px ${glowColor}, 0 0 20px ${glowColor}, 0 0 30px ${glowColor}`,
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.5 } }}
        >
            {title}
        </Button>
    );
};

export default ResumeButton;
